module.exports = __webpack_public_path__ + "img/Apop_Logo_lg.11d78d2b.png";